import React, { useState } from 'react';
import PropTypes from 'prop-types';
import '../../../css/svg.css';

const KansasMap = ({ onZoneClick }) => {
	const [selectedZone, setSelectedZone] = useState(null);

	const handleZoneClick = (zoneId) => {
		setSelectedZone(zoneId);
		if (onZoneClick) {
			onZoneClick(zoneId);
		}
		console.log('Zone Clicked: %s', zoneId);
	};

	return (
		<svg id='kansas' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 1000 1000' className='map'>
			<polygon
				id='KS_ZS'
				points='892.38 536.79 897.52 713.5 442.63 713.5 275.58 708.01 155.58 705.66 164.83 508.94 448.13 525.72 770.95 536.79 892.38 536.79'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'KS_ZS' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('KS_ZS')}
			/>
			<polygon
				id='KS_ZN'
				points='892.38 536.79 889.68 443.7 841.83 391.94 841.83 378.61 860.66 360.57 856.74 350.37 824.58 337.82 814.38 331.55 452.03 331.55 173.68 320.92 164.83 508.94 448.13 525.72 770.95 536.79 892.38 536.79'
				fill='#ccc'
				stroke='#fff'
				strokeMiterlimit='10'
				strokeWidth='3'
				className={`polygon ${selectedZone === 'KS_ZN' ? 'selected' : ''}`}
				onClick={() => handleZoneClick('KS_ZN')}
			/>
			<rect
				x='492.82'
				y='559.27'
				width='59.85'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M492.21,598.8l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M526.7,595.62c2.2,1.48,5.23,2.58,8.61,2.58,4.55,0,8.74-2.72,8.74-7.59,0-3.01-1.69-5.24-5.92-7.56-5.16-2.79-8.05-6.03-8.05-10.37,0-7.24,6.22-11.87,13.65-11.87,3.95,0,6.89,1.15,8.28,2.1l-1.77,4.07c-1.27-.76-3.8-1.93-7.02-1.9-4.99,0-8.01,3.29-8.02,6.61,0,3.28,2.05,5.15,6.28,7.5,4.98,2.67,7.71,5.86,7.71,10.82,0,6.99-5.49,12.5-14.59,12.5-4.04,0-8.04-1.32-9.73-2.81l1.8-4.07Z'
				className='shape'
			/>
			<rect
				x='441.29'
				y='401.54'
				width='73.15'
				height='43.33'
				fill='none'
				className='shape'
			/>
			<path
				d='M440.67,441.06l27.45-32.89-.03-.18h-19.24l.83-4.29h25.94l-.63,3.23-27.25,32.74.06.18h21.25l-.82,4.29h-28.12l.56-3.08Z'
				className='shape'
			/>
			<path
				d='M474.53,444.14l7.69-40.44h5.45l9.26,22.9c1.79,4.6,2.7,7.8,3.55,11.28l.13-.06c.22-3.63.64-6.99,1.69-12.66l4.08-21.45h4.71l-7.69,40.44h-4.92l-9.22-22.86c-1.97-5-2.87-7.84-3.75-11.67l-.18.06c-.45,3.78-1.09,7.82-2.12,13.32l-3.99,21.14h-4.69Z'
				className='shape'
			/>
			<polygon
				points='308.66 634.4 308.76 638.72 313.31 638.72 308.83 641.4 308.94 645.72 306.06 643.05 301.58 645.72 304.28 641.4 301.41 638.72 305.95 638.72 308.66 634.4'
				className='shape'
			/>
			<rect x='312.83' y='617.32' width='128.45' height='20' fill='none' className='shape' />
			<path
				d='M316.62,618.4c1.24-.22,2.6-.32,4.02-.32,2.7,0,4.76.77,5.95,2.15.87.9,1.51,2.35,1.52,4.39,0,2.93-1.16,5.83-3.25,7.6-1.87,1.57-4.23,2.25-7.33,2.25-1.41,0-2.87-.08-3.92-.2l3.01-15.87ZM315.89,632.71c.73.1,1.49.11,2.09.11,2.57,0,4.44-.76,5.79-2.15,1.46-1.49,2.21-3.69,2.21-5.97,0-2.86-1.4-5-5.43-5-.72,0-1.63.04-2.21.17l-2.44,12.84Z'
				className='shape'
			/>
			<path
				d='M342.87,627.32c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM333.94,629.78c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M359.1,617.32l-2.55,13.36c-.22,1.2-.42,2.56-.49,3.68h-1.82l.31-2.3h-.05c-1.06,1.65-2.52,2.56-4.19,2.56-2.24,0-3.47-1.84-3.47-4.22,0-4.13,3.07-7.91,7.18-7.91.73,0,1.55.16,2.05.4l1.04-5.57h1.98ZM355.75,624.57c-.4-.27-1.07-.49-1.9-.49-2.79,0-4.95,2.97-4.95,6.05,0,1.41.48,2.86,2.19,2.86,1.53,0,3.38-1.75,3.88-4.36l.78-4.06Z'
				className='shape'
			/>
			<path
				d='M361.88,637c.71.45,1.86.76,3.08.76,1.95,0,3.48-.99,4.17-4.13l.38-1.74h-.06c-1.02,1.66-2.43,2.47-4.04,2.47-2.33,0-3.53-1.96-3.54-4.02,0-3.95,2.88-7.84,7.37-7.84,1.35,0,2.81.38,3.73.81l-1.78,9.59c-.47,2.46-1.13,4.16-2.34,5.2-1.16,1-2.73,1.29-4.05,1.29-1.41,0-2.75-.33-3.48-.82l.56-1.56ZM370.8,624.48c-.37-.18-1.09-.4-1.92-.4-2.9,0-4.9,3.04-4.92,5.9,0,1.29.46,2.78,2.22,2.78s3.44-2.16,3.87-4.42l.74-3.87Z'
				className='shape'
			/>
			<path
				d='M385.14,633.7c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM382.94,624.04c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M408.11,633.84c-.91.41-2.38.78-4.2.78-4.07,0-6.57-2.59-6.57-6.72,0-3.05,1.23-5.95,3.45-7.8,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.26,1.63Z'
				className='shape'
			/>
			<path
				d='M412.58,634.36l2.22-11.61h1.99l-2.22,11.61h-1.99ZM415.17,619.51c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.79-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M425.7,619.64l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.13-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M433.23,622.76l1.15,6.24c.26,1.34.41,2.19.52,3.06h.06c.31-.74.65-1.56,1.23-2.84l2.97-6.46h2.11l-4.36,8.82c-1.25,2.52-2.42,4.55-4,6.11-1.3,1.31-2.71,1.86-3.38,2l-.49-1.71c.5-.18,1.34-.5,2.13-1.12.79-.61,1.62-1.54,2.24-2.68.1-.19.09-.32.06-.53l-2.33-10.9h2.07Z'
				className='shape'
			/>
			<polygon
				points='578.07 630.2 578.18 634.53 582.72 634.53 578.24 637.2 578.35 641.52 575.47 638.85 570.99 641.52 573.7 637.2 570.82 634.53 575.37 634.53 578.07 630.2'
				className='shape'
			/>
			<rect x='582.24' y='613.13' width='90.59' height='20' fill='none' className='shape' />
			<path
				d='M585.37,630.17l-.79-16.18h2l.34,9.7c.06,2.09.02,3.2,0,4.21h.06c.38-1.06.77-2.1,1.66-4.1l4.48-9.81h2.13l.33,9.31c.07,2.1.07,3.5.04,4.57h.05c.48-1.39.96-2.69,1.58-4.16l4.36-9.71h2.09l-7.51,16.18h-2.11l-.41-9.2c-.09-1.88-.07-2.8.04-4.66h-.06c-.54,1.55-.97,2.79-1.63,4.26l-4.51,9.6h-2.13Z'
				className='shape'
			/>
			<path
				d='M605.05,630.17l2.22-11.61h1.99l-2.22,11.61h-1.99ZM607.64,615.32c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M620.96,629.71c-.59.29-1.79.71-3.37.71-2.99,0-4.46-2.03-4.46-4.49,0-3.96,2.95-7.63,7.12-7.63,1.08,0,2.06.32,2.41.53l-.57,1.58c-.46-.22-1.1-.44-1.97-.44-3.01,0-4.92,2.97-4.92,5.71,0,1.89.99,3.11,2.89,3.11,1.18,0,2.09-.36,2.68-.65l.19,1.57Z'
				className='shape'
			/>
			<path
				d='M625.55,630.17l3.24-17.04h1.99l-1.45,7.48h.05c1-1.41,2.4-2.31,4.15-2.31,1.32,0,2.89.8,2.89,3.11,0,.62-.08,1.38-.19,1.96l-1.29,6.8h-1.99l1.27-6.71c.08-.42.16-.96.16-1.6,0-1.07-.51-1.91-1.8-1.91-1.54,0-3.47,1.8-3.95,4.4l-1.08,5.82h-1.99Z'
				className='shape'
			/>
			<path
				d='M640.79,630.17l2.22-11.61h1.99l-2.22,11.61h-1.99ZM643.37,615.32c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M653.9,615.44l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.13,1.1,1.13.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M666.32,630.17c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM667.61,620.04c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<polygon
				points='879.52 438 879.63 442.33 884.17 442.33 879.69 445 879.8 449.32 876.92 446.65 872.44 449.32 875.15 445 872.27 442.33 876.82 442.33 879.52 438'
				className='shape'
			/>
			<rect x='734.95' y='444.26' width='136.31' height='20' fill='none' className='shape' />
			<path
				d='M738.77,445.12h1.97l-1.49,7.87h.1c.56-.7,1.1-1.27,1.6-1.83l5.69-6.04h2.49l-6.81,6.96,4.15,9.22h-2.16l-3.54-7.94-1.93,1.8-1.18,6.14h-1.97l3.08-16.18Z'
				className='shape'
			/>
			<path
				d='M758.13,461.3c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM759.42,451.18c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M765.44,461.3l1.55-8.23c.26-1.29.42-2.42.55-3.38h1.79l-.3,2.28h.05c1.04-1.63,2.61-2.54,4.31-2.54,1.38,0,2.94.79,2.94,3.22,0,.52-.09,1.25-.21,1.87l-1.29,6.78h-1.99l1.27-6.71c.08-.45.16-.99.16-1.49,0-1.16-.45-2.02-1.82-2.02s-3.44,1.7-3.97,4.57l-1.05,5.64h-1.99Z'
				className='shape'
			/>
			<path
				d='M780.77,459.28c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.82-4.43,3.82-1.25,0-2.36-.39-2.89-.79l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M799.75,461.3c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.83,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.1-.49,5.38h-1.86ZM801.04,451.18c-.28-.09-.71-.17-1.38-.17-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
			<path
				d='M807.15,459.28c.55.33,1.54.72,2.5.72,1.34,0,2.21-.87,2.21-1.89,0-.91-.41-1.47-1.61-2.14-1.34-.74-2.1-1.77-2.1-2.96,0-2.03,1.76-3.58,4.21-3.58,1.05,0,1.98.28,2.42.58l-.56,1.5c-.4-.23-1.13-.53-2-.53-1.21,0-2.07.76-2.07,1.74,0,.85.56,1.37,1.6,1.95,1.29.73,2.17,1.75,2.17,3.05,0,2.44-1.98,3.82-4.43,3.82-1.25,0-2.36-.39-2.89-.79l.57-1.47Z'
				className='shape'
			/>
			<path
				d='M836.47,460.78c-.91.41-2.38.77-4.2.77-4.07,0-6.57-2.59-6.57-6.72,0-3.04,1.23-5.95,3.45-7.79,1.67-1.41,3.73-2.17,6.1-2.17,1.8,0,3.09.45,3.51.78l-.64,1.61c-.6-.36-1.74-.67-3.18-.67-1.69,0-3.39.66-4.63,1.81-1.52,1.42-2.48,3.7-2.48,6.16,0,2.89,1.33,5.28,4.92,5.28,1.22,0,2.56-.24,3.46-.69l.26,1.63Z'
				className='shape'
			/>
			<path
				d='M840.94,461.3l2.22-11.61h1.99l-2.22,11.61h-1.99ZM843.52,446.45c0-.77.59-1.35,1.31-1.35s1.19.52,1.19,1.25c-.02.78-.58,1.34-1.35,1.34-.7,0-1.16-.54-1.14-1.24Z'
				className='shape'
			/>
			<path
				d='M854.05,446.57l-.6,3.12h2.77l-.31,1.56h-2.78l-1.07,5.64c-.13.65-.23,1.25-.23,1.85,0,.69.33,1.12,1.1,1.12.36,0,.68-.03.94-.09l-.1,1.57c-.35.14-.96.21-1.54.21-1.75,0-2.44-1.06-2.44-2.25,0-.68.09-1.34.25-2.18l1.13-5.88h-1.66l.3-1.56h1.67l.49-2.62,2.07-.5Z'
				className='shape'
			/>
			<path
				d='M861.59,449.69l1.15,6.24c.26,1.34.41,2.19.52,3.06h.06c.31-.74.65-1.56,1.23-2.84l2.97-6.46h2.11l-4.36,8.82c-1.25,2.52-2.42,4.55-4,6.11-1.3,1.31-2.71,1.86-3.38,2l-.49-1.71c.5-.17,1.34-.5,2.13-1.12.79-.61,1.62-1.54,2.24-2.68.1-.19.09-.33.06-.53l-2.33-10.9h2.07Z'
				className='shape'
			/>
			<polygon
				points='702.62 425.91 702.73 430.23 707.27 430.23 702.79 432.91 702.9 437.23 700.03 434.56 695.55 437.23 698.25 432.91 695.37 430.23 699.92 430.23 702.62 425.91'
				className='shape'
			/>
			<rect x='615.23' y='409.34' width='85.52' height='20' fill='none' className='shape' />
			<path
				d='M621.52,411.93h-4.73l.34-1.73h11.46l-.34,1.73h-4.75l-2.74,14.45h-1.99l2.74-14.45Z'
				className='shape'
			/>
			<path
				d='M639.43,419.33c0,3.59-2.55,7.31-6.45,7.31-2.91,0-4.53-2.16-4.53-4.77,0-3.83,2.66-7.37,6.44-7.37,3.13,0,4.54,2.37,4.54,4.83ZM630.5,421.79c0,1.89,1.05,3.27,2.75,3.27,2.34,0,4.12-3.04,4.12-5.73,0-1.36-.63-3.25-2.71-3.25-2.51,0-4.17,3.05-4.17,5.71Z'
				className='shape'
			/>
			<path
				d='M642.2,431.13l2.32-12.25c.26-1.4.5-2.94.65-4.11h1.82l-.33,2.19h.05c1.05-1.53,2.58-2.45,4.18-2.45,2.52,0,3.58,2.07,3.58,4.19,0,4.09-2.93,7.94-6.8,7.94-1.23,0-2.05-.27-2.5-.52h-.05l-.94,5.01h-1.98ZM645.46,424.43c.51.4,1.27.64,2.22.64,2.57,0,4.71-3.19,4.71-6.22,0-1.22-.54-2.69-2.23-2.69-1.57,0-3.51,1.78-4.12,5.03l-.59,3.24Z'
				className='shape'
			/>
			<path
				d='M666.71,425.71c-.88.49-2.28.92-3.84.92-3.08,0-4.42-2.1-4.42-4.67,0-3.5,2.6-7.45,6.33-7.45,2.21,0,3.41,1.32,3.41,2.98,0,3.05-3.44,3.85-7.73,3.77-.1.5-.03,1.59.23,2.21.47,1.05,1.39,1.56,2.58,1.56,1.38,0,2.42-.41,3.13-.79l.29,1.48ZM664.51,416.05c-1.9,0-3.33,1.85-3.81,3.67,3.13.04,5.58-.38,5.58-2.19,0-.95-.73-1.48-1.77-1.48Z'
				className='shape'
			/>
			<path
				d='M671.64,426.38l3.24-17.04h1.98l-2.04,10.68h.05c.35-.41.78-.85,1.09-1.17l4.09-4.08h2.46l-5.06,4.76,3.47,6.84h-2.19l-2.79-5.73-1.47,1.31-.83,4.42h-1.98Z'
				className='shape'
			/>
			<path
				d='M692.36,426.38c0-.7.11-1.8.26-3h-.05c-1.25,2.41-2.86,3.26-4.49,3.26-2.06,0-3.34-1.63-3.34-3.84,0-4.04,2.98-8.3,8.02-8.3,1.11,0,2.33.19,3.13.44l-1.18,6.05c-.38,2.02-.54,4.09-.49,5.38h-1.86ZM693.66,416.25c-.28-.09-.71-.16-1.38-.16-3.01,0-5.46,3.13-5.47,6.36,0,1.3.45,2.56,1.98,2.56,1.67,0,3.62-2.16,4.2-5.25l.67-3.5Z'
				className='shape'
			/>
		</svg>
	);
};

KansasMap.propTypes = {
	onZoneClick: PropTypes.func.isRequired,
	selectedZone: PropTypes.string,
};

export default KansasMap;
